import { render } from "./ExternalTransfer.vue?vue&type=template&id=e1048c04&scoped=true"
import script from "./ExternalTransfer.vue?vue&type=script&lang=js"
export * from "./ExternalTransfer.vue?vue&type=script&lang=js"

import "./ExternalTransfer.vue?vue&type=style&index=0&id=e1048c04&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1048c04"]])

export default __exports__